module.exports = __webpack_public_path__ + "img/design-for-delight.1d53dc89.svg";